import firebase from "firebase";
import { Subtask } from "@fpd-cloud/schemas/core";
const { fromDate } = firebase.firestore.Timestamp;

export const subTaskConverter = {
  toFirestore(u: Subtask): firebase.firestore.DocumentData {
    const d: firebase.firestore.DocumentData = { ...u };
    if (u.createdAt) d.createdAt = fromDate(new Date(u.createdAt));
    if (u.updatedAt) d.updatedAt = fromDate(new Date(u.updatedAt));
    return d;
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions
  ): Subtask {
    const data = snapshot.data(options) as Subtask;
    return {
      ...data,
      createdAt: data.createdAt || new Date(),
      updatedAt: data.updatedAt || new Date()
    };
  }
};
